//api
import http from "@/plugins/http";

/**
 * 实例代码
 * @param {Object} params 需要传的参数
 */

/***登录****/
export function get_login(params) {
  return http({
    url: "/base/oauthdata/login",
    // url: "/base/oauthdata/login2",
    method: "post",
    data:{ ...params }
  });
}


/***考试项目-分页查询****/
export function exam_list_pages(params) {
  return http({
    url: "/base/work/pageList",
    method: "post",
    headers:{
      token: localStorage.getItem("ydj_token")?localStorage.getItem("ydj_token"):null
    },
    data:{...params}
  });
}

/***年级列表****/
export function get_grade_list(params) {
  return http({
    url: "/base/oauthdata/getGrade",
    method: "post",
    headers:{
      token: localStorage.getItem("ydj_token")?localStorage.getItem("ydj_token"):null
    },
    data:{...params}
  });
}

/***班级列表****/
export function get_class_list(params) {
  return http({
    url: "/base/oauthdata/getClass",
    method: "post",
    headers:{
      token: localStorage.getItem("ydj_token")?localStorage.getItem("ydj_token"):null
    },
    data:{...params}
  });
}

/***科目列表****/
export function get_subject_list(params) {
  return http({
    url: "/base/oauthdata/getSubject",
    method: "post",
    headers:{
      token: localStorage.getItem("ydj_token")?localStorage.getItem("ydj_token"):null
    },
    data:{...params}
  });
}

/***参考科目列表****/
export function get_subject_byexam(params) {
  return http({
    url: "/base/oauthdata/getSubjectData",
    method: "post",
    headers:{
      token: localStorage.getItem("ydj_token")?localStorage.getItem("ydj_token"):null
    },
    data:{...params}
  });
}

/***新建项目****/
export function add_exam(params) {
  return http({
    url: "/base/work/homeWorkadd",
    method: "post",
    headers:{
      token: localStorage.getItem("ydj_token")?localStorage.getItem("ydj_token"):null
    },
    data:{...params}
  });
}

/***删除项目****/
export function del_exam(params) {
  return http({
    url: "/base/work/del",
    method: "post",
    headers:{
      token: localStorage.getItem("ydj_token")?localStorage.getItem("ydj_token"):null
    },
    data:{...params}
  });
}

/***复制项目****/
export function copy_exam(params) {
  return http({
    url: "/base/work/copyAdd",
    method: "post",
    headers:{
      token: localStorage.getItem("ydj_token")?localStorage.getItem("ydj_token"):null
    },
    data:{...params}
  });
}

/***编辑项目****/
export function update_exam(params) {
  return http({
    // url: "/base/work/update",
    url: "/base/work/homeWorkupdate",
    method: "post",
    headers:{
      token: localStorage.getItem("ydj_token")?localStorage.getItem("ydj_token"):null
    },
    data:{...params}
  });
}

/***学生列表查询****/
export function get_stu_list_pages(params) {
  return http({
    url: "/base/workstudent/getStudentData",
    method: "post",
    headers:{
      token: localStorage.getItem("ydj_token")?localStorage.getItem("ydj_token"):null
    },
    data:{...params}
  });
}

/***学生信息-引入基础****/
export function get_stu_list_pages_new(params) {
  return http({
    url: "/base/workstudent/studentrenew",
    method: "post",
    headers:{
      token: localStorage.getItem("ydj_token")?localStorage.getItem("ydj_token"):null
    },
    data:{...params}
  });
}

/***学生信息-更新基础****/
export function update_stu_base(params) {
  return http({
    url: "/base/workstudent/baseUpdate",
    method: "post",
    headers:{
      token: localStorage.getItem("ydj_token")?localStorage.getItem("ydj_token"):null
    },
    data:{...params}
  });
}

/***标答保存****/
export function save_set_answer(params) {
  return http({
    url: "/base/work/setadd",
    method: "post",
    headers:{
      token: localStorage.getItem("ydj_token")?localStorage.getItem("ydj_token"):null
    },
    data:{...params}
  });
}

/***获取标答****/
export function get_set_answer(params) {
  return http({
    url: "/base/work/getSettingid",
    method: "post",
    headers:{
      token: localStorage.getItem("ydj_token")?localStorage.getItem("ydj_token"):null
    },
    data:{...params}
  });
}

/***获取格式文件****/
export function get_formatfile(params) {
  return http({
    url: "/base/oauthdata/getCardList",
    method: "post",
    headers:{
      token: localStorage.getItem("ydj_token")?localStorage.getItem("ydj_token"):null
    },
    data:{...params}
  });
}

/***获取格式文件详情****/
export function get_formatfile_detail(params) {
  return http({
    url: "/base/oauthdata/getCardInfoById",
    method: "post",
    headers:{
      token: localStorage.getItem("ydj_token")?localStorage.getItem("ydj_token"):null
    },
    data:{...params}
  });
}

/***获取试卷录入详情****/
export function get_paper_detail(params) {
  return http({
    url: "/base/work/getAnsweraid",
    method: "post",
    headers:{
      token: localStorage.getItem("ydj_token")?localStorage.getItem("ydj_token"):null
    },
    data:{...params}
  });
}

/***获取试卷录入详情****/
export function get_stu_list(params) {
  return http({
    url: "/base/workstudent/list",
    method: "post",
    headers:{
      token: localStorage.getItem("ydj_token")?localStorage.getItem("ydj_token"):null
    },
    data:{...params}
  });
}

/***试卷录入****/
export function save_paper(params) {
  return http({
    url: "/base/work/answeradd",
    method: "post",
    headers:{
      token: localStorage.getItem("ydj_token")?localStorage.getItem("ydj_token"):null
    },
    data:{...params}
  });
}

/***试卷录入-覆盖重复考号数据****/
export function cover_paper(params) {
  return http({
    url: "/base/work/answercover",
    method: "post",
    headers:{
      token: localStorage.getItem("ydj_token")?localStorage.getItem("ydj_token"):null
    },
    data:{...params}
  });
}

/***试卷录入单条数据删除****/
export function del_paper(params) {
  return http({
    url: "/base/work/getanswerdelid",
    method: "post",
    headers:{
      token: localStorage.getItem("ydj_token")?localStorage.getItem("ydj_token"):null
    },
    data:{...params}
  });
}

/***试卷录入全部删除****/
export function clear_paper(params) {
  return http({
    url: "/base/work/answerdel",
    method: "post",
    headers:{
      token: localStorage.getItem("ydj_token")?localStorage.getItem("ydj_token"):null
    },
    data:{...params}
  });
}

/***试卷录入修改作业号****/
export function answerUpdate(params) {
  return http({
    url: "/base/work/answerUpdate",
    method: "post",
    headers:{
      token: localStorage.getItem("ydj_token")?localStorage.getItem("ydj_token"):null
    },
    data:{...params}
  });
}

//成绩分析

/***考试项目-科目考试下分析计算****/
export function result_calculate(params) {
  return http({
    url: "/base/worksubject/scoretally",
    method: "post",
    headers:{
      token: localStorage.getItem("ydj_token")?localStorage.getItem("ydj_token"):null
    },
    data:{...params}
  });
}

/***成绩单****/
export function resultpagelist(params) {
  return http({
    url: "/base/studentAnswer/pageList",
    method: "post",
    headers:{
      token: localStorage.getItem("ydj_token")?localStorage.getItem("ydj_token"):null
    },
    data:{...params}
  });
}

/***小题分****/
export function smallpageList(params) {
  return http({
    url: "/base/stuanalys/smallpageList",
    method: "post",
    headers:{
      token: localStorage.getItem("ydj_token")?localStorage.getItem("ydj_token"):null
    },
    data:{...params}
  });
}

/***字母列表查询****/
export function letterList(params) {
  return http({
    url: "/base/oauthdata/getoptionList",
    method: "post",
    headers:{
      token: localStorage.getItem("ydj_token")?localStorage.getItem("ydj_token"):null
    },
    data:{...params}
  });
}

/***正答率查询****/
export function answerpageList(params) {
  return http({
    url: "/base/stuanalys/answerpageList",
    method: "post",
    headers:{
      token: localStorage.getItem("ydj_token")?localStorage.getItem("ydj_token"):null
    },
    data:{...params}
  });
}

/***错误题目追踪****/
export function errorpageList(params) {
  return http({
    url: "/base/stuanalys/errorpageList",
    method: "post",
    headers:{
      token: localStorage.getItem("ydj_token")?localStorage.getItem("ydj_token"):null
    },
    data:{...params}
  });
}

/***多科成绩分析****/
export function moresubjectpageList(params) {
  return http({
    url: "/base/studentAnswer/pageList2",
    method: "post",
    headers:{
      token: localStorage.getItem("ydj_token")?localStorage.getItem("ydj_token"):null
    },
    data:{...params}
  });
}

/***学生历次考试成绩分析查询****/
export function historypageList(params) {
  return http({
    url: "/base/stuanalys/historypageList",
    method: "post",
    headers:{
      token: localStorage.getItem("ydj_token")?localStorage.getItem("ydj_token"):null
    },
    data:{...params}
  });
}

/***班级综合指标查询****/
export function classNormList(params) {
  return http({
    url: "/base/stuanalys/classNormList",
    method: "post",
    headers:{
      token: localStorage.getItem("ydj_token")?localStorage.getItem("ydj_token"):null
    },
    data:{...params}
  });
}

/***分数段统计-分数段设置****/
export function scoreAdd(params) {
  return http({
    url: "/base/stuanalys/scoreAdd",
    method: "post",
    headers:{
      token: localStorage.getItem("ydj_token")?localStorage.getItem("ydj_token"):null
    },
    data:{...params}
  });
}

/***分数段统计-分数段设置查询****/
export function getscoreAddid(params) {
  return http({
    url: "/base/stuanalys/getscoreAddid",
    method: "post",
    headers:{
      token: localStorage.getItem("ydj_token")?localStorage.getItem("ydj_token"):null
    },
    data:{...params}
  });
}

/***分数段统计****/
export function scoreInstallList(params) {
  return http({
    url: "/base/stuanalys/scoreInstallList",
    method: "post",
    headers:{
      token: localStorage.getItem("ydj_token")?localStorage.getItem("ydj_token"):null
    },
    data:{...params}
  });
}

/***赋分成绩单****/
export function assignPoints(params) {
  return http({
    url: "/base/studentAnswer/assignPoints",
    method: "post",
    headers:{
      token: localStorage.getItem("ydj_token")?localStorage.getItem("ydj_token"):null
    },
    data:{...params}
  });
}

/***根据考试项目-查询班级****/
export function getClassData(params) {
  return http({
    url: "/base/oauthdata/getClassData",
    method: "post",
    headers:{
      token: localStorage.getItem("ydj_token")?localStorage.getItem("ydj_token"):null
    },
    data:{...params}
  });
}

/***关注学生-添加列表查询****/
export function ationList(params) {
  return http({
    url: "/base/workstudent/ationList",
    method: "post",
    headers:{
      token: localStorage.getItem("ydj_token")?localStorage.getItem("ydj_token"):null
    },
    data:{...params}
  });
}

/***关注学生-添加****/
export function ationAdd(params) {
  return http({
    url: "/base/workstudent/ationAdd",
    method: "post",
    headers:{
      token: localStorage.getItem("ydj_token")?localStorage.getItem("ydj_token"):null
    },
    data:{...params}
  });
}

/***关注学生考试信息列表查询****/
export function getStudentAtionList(params) {
  return http({
    url: "/base/workstudent/getStudentAtionList",
    method: "post",
    headers:{
      token: localStorage.getItem("ydj_token")?localStorage.getItem("ydj_token"):null
    },
    data:{...params}
  });
}

/***概况分析查询****/
export function getoverview(params) {
  return http({
    url: "/base/stuanalys/getoverview",
    method: "post",
    headers:{
      token: localStorage.getItem("ydj_token")?localStorage.getItem("ydj_token"):null
    },
    data:{...params}
  });
}

/***讲评接口****/
export function jiangping(params) {
  return http({
    url: "/base/worksubject/jiangping",
    method: "post",
    headers:{
      token: localStorage.getItem("ydj_token")?localStorage.getItem("ydj_token"):null
    },
    data:{...params}
  });
}

/***考试项目-试卷录入-是否同步主观分****/
export function imageadd(params) {
  return http({
    url: "/base/work/imageadd",
    method: "post",
    headers:{
      token: localStorage.getItem("ydj_token")?localStorage.getItem("ydj_token"):null
    },
    data:{...params}
  });
}

/***报告分析-分题段统计查询-分页查询****/
export function settingInstallList(params) {
  return http({
    url: "/base/stuanalys/settingInstallList",
    method: "post",
    headers:{
      token: localStorage.getItem("ydj_token")?localStorage.getItem("ydj_token"):null
    },
    data:{...params}
  });
}

/***报告分析-分数段统计-分题段设置查询****/
export function getsettingAddid(params) {
  return http({
    url: "/base/stuanalys/getsettingAddid",
    method: "post",
    headers:{
      token: localStorage.getItem("ydj_token")?localStorage.getItem("ydj_token"):null
    },
    data:{...params}
  });
}

/***报告分析-分数段统计-分题段设置****/
export function settingAdd(params) {
  return http({
    url: "/base/stuanalys/settingAdd",
    method: "post",
    headers:{
      token: localStorage.getItem("ydj_token")?localStorage.getItem("ydj_token"):null
    },
    data:{...params}
  });
}

/***消息通知****/
export function workNotice(params) {
  return http({
    url: "/base/worksubject/workNotice",
    method: "post",
    headers:{
      token: localStorage.getItem("ydj_token")?localStorage.getItem("ydj_token"):null
    },
    data:{...params}
  });
}

/***多科混读****/
export function manysubadd(params) {
  return http({
    url: "/base/work/manysubadd",
    method: "post",
    headers:{
      token: localStorage.getItem("ydj_token")?localStorage.getItem("ydj_token"):null
    },
    data:{...params}
  });
}

/***多科混读-覆盖****/
export function manysubCover(params) {
  return http({
    url: "/base/work/manysubCover",
    method: "post",
    headers:{
      token: localStorage.getItem("ydj_token")?localStorage.getItem("ydj_token"):null
    },
    data:{...params}
  });
}

/***多科混读-查询****/
export function getManysubid(params) {
  return http({
    url: "/base/work/getManysubid",
    method: "post",
    headers:{
      token: localStorage.getItem("ydj_token")?localStorage.getItem("ydj_token"):null
    },
    data:{...params}
  });
}

/***多科混读-清空****/
export function manysubdel(params) {
  return http({
    url: "/base/work/manysubdel",
    method: "post",
    headers:{
      token: localStorage.getItem("ydj_token")?localStorage.getItem("ydj_token"):null
    },
    data:{...params}
  });
}

/***多科混读-删除****/
export function getManysubdelid(params) {
  return http({
    url: "/base/work/getManysubdelid",
    method: "post",
    headers:{
      token: localStorage.getItem("ydj_token")?localStorage.getItem("ydj_token"):null
    },
    data:{...params}
  });
}

/***试卷录入-未读卡学生信息查询-分页查询****/
export function getSettingAnswerListPage(params) {
  return http({
    url: "/base/studentAnswer/getSettingAnswerListPage",
    method: "post",
    headers:{
      token: localStorage.getItem("ydj_token")?localStorage.getItem("ydj_token"):null
    },
    data:{...params}
  });
}

/***根据考试id和科目id查询题库试题信息****/
export function getTestQuestionInfo(params) {
  return http({
    url: "/base/oauthdata/getTestQuestionInfo",
    method: "post",
    headers:{
      token: localStorage.getItem("ydj_token")?localStorage.getItem("ydj_token"):null
    },
    data:{...params}
  });
}

/***根据考试id和科目id删除题库试题信息****/
export function delTestPro2Que(params) {
  return http({
    url: "/base/oauthdata/delTestPro2Que",
    method: "post",
    headers:{
      token: localStorage.getItem("ydj_token")?localStorage.getItem("ydj_token"):null
    },
    data:{...params}
  });
}
/***学校阅读机列表****/
export function getOmrList(params) {
  return http({
    url: "/base/oauthdata/getOmrList",
    method: "post",
    headers:{
      token: localStorage.getItem("ydj_token")?localStorage.getItem("ydj_token"):null
    },
    data:{...params}
  });
}

/***获取加密用户名****/
export function getSkipToken(params) {
  return http({
    url: "/base/oauthdatapt/getSkipToken",
    method: "post",
    headers:{
      token: localStorage.getItem("ydj_token")?localStorage.getItem("ydj_token"):null
    },
    data:{...params}
  });
}